import React, { useEffect, useState, createElement } from 'react';
import { Flame, CheckCircle2, ShieldCheck, Zap, Download, Lock, Clock, Sparkles, MessageSquare, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouOfferPage() {
  // 15-minute countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Offer-View');
    // Countdown
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-amber-400 selection:text-black" data-id="element-3347">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3348">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3349" />
      </noscript>

      {/* Urgency Top Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-black py-2.5 px-4 shadow-lg" data-id="element-3350">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-3351">
          <Flame className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" data-id="element-3352" />
          <p className="text-xs md:text-sm font-black uppercase tracking-wide" data-id="element-3353">
            OFERTA EXCLUSIVA — EXPIRA EN{' '}
            <span className="font-mono bg-black text-amber-400 px-2 py-0.5 rounded ml-1" data-id="element-3354">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
      </div>

      {/* Registration Incomplete Alert — keeps visitors on page */}
      <div className="bg-red-600 py-2 px-4" data-id="element-3355">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-3356">
          <AlertTriangle className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-3357" />
          <p className="text-white font-bold text-xs md:text-sm uppercase tracking-tight leading-tight" data-id="element-3358">
            Tu registración al webinar no está completa aún
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-3359">
        {/* Hero Section */}
        <section className="text-center mb-10 md:mb-16" data-id="element-3360">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-3361">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-3362" />
            <span className="text-amber-400 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-3363">
              Solo durante los próximos 15 minutos
            </span>
          </div>

          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black leading-[1.15] tracking-tight mb-5 md:mb-6" data-id="element-3364">
            Antes de Cerrar Esta Página...
            <br data-id="element-3365" />
            <span className="text-amber-400" data-id="element-3366">
              Lleva los 200 Mensajes EXACTOS
            </span>{' '}
            Que Mis Alumnos Están Usando Para Cerrar Clientes Locales —{' '}
            <span className="text-white underline decoration-amber-400 decoration-4 underline-offset-4" data-id="element-3367">
              Por Solo $27
            </span>
          </h1>

          <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-3368">
            El manual completo con{' '}
            <span className="text-white font-bold" data-id="element-3369">
              200 mensajes WhatsApp listos para copiar y pegar
            </span>{' '}
            — organizados por nicho y situación — para que ejecutes desde el{' '}
            <span className="text-amber-400 font-bold" data-id="element-3370">JUEVES</span> en cuanto
            termine el webinar.
          </p>
        </section>

        {/* Problem Section */}
        <section className="mb-10 md:mb-14" data-id="element-3371">
          <div className="bg-gradient-to-br from-red-950/40 to-[#0a0e1a] border border-red-500/20 rounded-2xl p-6 md:p-10" data-id="element-3372">
            <div className="flex items-start gap-3 mb-5" data-id="element-3373">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-red-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-3374">
                <span className="text-2xl" data-id="element-3375">😬</span>
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-3376">
                El Problema Real
              </h2>
            </div>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 pl-0 md:pl-[60px]" data-id="element-3377">
              <p data-id="element-3378">Mira, te soy directo:</p>
              <p data-id="element-3379">
                El jueves vas a salir del webinar emocionado. Vas a querer
                mandar tu primer mensaje. Vas a abrir WhatsApp...
              </p>
              <p data-id="element-3380">Y te vas a quedar mirando la pantalla en blanco pensando:</p>
              <p className="text-white italic border-l-2 border-amber-400 pl-4 my-5" data-id="element-3381">
                "¿Qué le escribo a este dentista? ¿Cómo abro la conversación sin
                sonar a vendedor desesperado? ¿Y si me ignora?"
              </p>
              <p data-id="element-3382">
                Eso le pasa al{' '}
                <span className="text-red-400 font-bold" data-id="element-3383">80%</span> de los que
                toman acción después de un webinar. Y por eso al{' '}
                <span className="text-red-400 font-bold" data-id="element-3384">
                  80% NO les funciona.
                </span>
              </p>
              <p className="text-white font-bold" data-id="element-3385">
                No es que el sistema sea malo. Es que NO tienen el copy
                correcto.
              </p>
            </div>
          </div>
        </section>

        {/* Solution Section */}
        <section className="mb-10 md:mb-14" data-id="element-3386">
          <div className="bg-gradient-to-br from-amber-950/40 to-[#0a0e1a] border border-amber-500/30 rounded-2xl p-6 md:p-10" data-id="element-3387">
            <div className="flex items-start gap-3 mb-5" data-id="element-3388">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-3389">
                <Zap className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-3390" />
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-3391">
                La Solución
              </h2>
            </div>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 pl-0 md:pl-[60px]" data-id="element-3392">
              <p data-id="element-3393">Por eso compilé este manual:</p>
              <ul className="space-y-3" data-id="element-3394">
                <li className="flex items-start gap-3" data-id="element-3395">
                  <span className="text-2xl flex-shrink-0" data-id="element-3396">📱</span>
                  <span data-id="element-3397">
                    <span className="text-white font-bold" data-id="element-3398">
                      200 mensajes EXACTOS
                    </span>
                    , palabra por palabra
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3399">
                  <span className="text-2xl flex-shrink-0" data-id="element-3400">🎯</span>
                  <span data-id="element-3401">
                    Organizados por{' '}
                    <span className="text-white font-bold" data-id="element-3402">6 nichos</span> (los
                    más rentables en USA)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3403">
                  <span className="text-2xl flex-shrink-0" data-id="element-3404">⚡</span>
                  <span data-id="element-3405">
                    Y por{' '}
                    <span className="text-white font-bold" data-id="element-3406">5 situaciones</span>{' '}
                    (primer contacto, follow-up, objeciones, cierre)
                  </span>
                </li>
              </ul>
              <p className="pt-2" data-id="element-3407">Cada mensaje tiene:</p>
              <ul className="space-y-2" data-id="element-3408">
                <li className="flex items-start gap-2" data-id="element-3409">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-3410" />
                  <span data-id="element-3411">Cuándo usarlo</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-3412">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-3413" />
                  <span data-id="element-3414">Variables editables ([NOMBRE], [CIUDAD], etc.)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-3415">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-3416" />
                  <span data-id="element-3417">Tip de psicología detrás de por qué funciona</span>
                </li>
              </ul>
              <p className="text-white font-bold pt-3" data-id="element-3418">
                Solo abres, eliges el mensaje correcto, reemplazas variables, y
                mandas.{' '}
                <span className="text-amber-400" data-id="element-3419">10 segundos por mensaje.</span>
              </p>
            </div>
          </div>
        </section>

        {/* What's Included Section */}
        <section className="mb-10 md:mb-14" data-id="element-3420">
          <div className="text-center mb-8" data-id="element-3421">
            <span className="inline-block bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold tracking-widest uppercase mb-4" data-id="element-3422">
              Lo Que Incluye
            </span>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-3423">
              Todo Lo Que Recibes Hoy
            </h2>
          </div>

          {/* Niches */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 mb-5" data-id="element-3424">
            <div className="flex items-center gap-3 mb-5" data-id="element-3425">
              <span className="text-3xl" data-id="element-3426">📕</span>
              <h3 className="text-lg md:text-2xl font-black text-white" data-id="element-3427">
                Los 6 Nichos Más Rentables{' '}
                <span className="text-amber-400" data-id="element-3428">(25 mensajes c/u)</span>
              </h3>
            </div>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-300 text-sm md:text-base" data-id="element-3429">
              {['Dentistas y clínicas médicas', 'Salones de belleza, barberías, spas', 'Restaurantes y bares', 'Abogados, contadores, notarios', 'Gimnasios y studios de fitness', 'Talleres mecánicos y servicios automotrices'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-3430">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-3431" />
                  <span data-id="element-3432">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Situations */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 mb-5" data-id="element-3433">
            <div className="flex items-center gap-3 mb-5" data-id="element-3434">
              <span className="text-3xl" data-id="element-3435">📕</span>
              <h3 className="text-lg md:text-2xl font-black text-white" data-id="element-3436">
                Las 5 Situaciones Clave{' '}
                <span className="text-amber-400" data-id="element-3437">(10 mensajes c/u)</span>
              </h3>
            </div>
            <ul className="space-y-3 text-gray-300 text-sm md:text-base" data-id="element-3438">
              {[{
              title: 'Primer contacto cold',
              desc: 'cómo abrir sin sonar a spam'
            }, {
              title: 'Cuando no responden',
              desc: 'cómo hacer follow-up sin molestar'
            }, {
              title: 'Cuando piden precio en WhatsApp',
              desc: 'cómo pivotar a llamada'
            }, {
              title: 'Manejo de objeciones',
              desc: '"está caro", "ya tengo web", etc.'
            }, {
              title: 'Cierre y agendamiento',
              desc: 'cómo mover a llamada SIN perder al lead'
            }].map(item => <li key={item.title} className="flex items-start gap-2.5" data-id="element-3439">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-3440" />
                  <span data-id="element-3441">
                    <span className="text-white font-semibold" data-id="element-3442">
                      {item.title}
                    </span>{' '}
                    <span className="text-gray-400" data-id="element-3443">({item.desc})</span>
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Bonuses */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-3444">
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-700/5 border border-amber-500/30 rounded-2xl p-6 md:p-7" data-id="element-3445">
              <div className="flex items-center gap-2 mb-3" data-id="element-3446">
                <span className="text-2xl" data-id="element-3447">🎁</span>
                <span className="text-amber-400 font-black text-xs uppercase tracking-wider" data-id="element-3448">
                  Bonus #1
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2" data-id="element-3449">
                Las 5 Reglas de Oro del WhatsApp Marketing
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-3450">
                Sin esto, los 200 mensajes no funcionan.
              </p>
            </div>
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-700/5 border border-amber-500/30 rounded-2xl p-6 md:p-7" data-id="element-3451">
              <div className="flex items-center gap-2 mb-3" data-id="element-3452">
                <span className="text-2xl" data-id="element-3453">🎁</span>
                <span className="text-amber-400 font-black text-xs uppercase tracking-wider" data-id="element-3454">
                  Bonus #2
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2" data-id="element-3455">
                Plantilla editable en Google Docs
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-3456">
                Para que personalices y guardes tus versiones favoritas.
              </p>
            </div>
          </div>
        </section>

        {/* Unified Value + CTA + Pricing Section */}
        <section className="mb-8" data-id="element-3457">
          <div className="bg-gradient-to-br from-[#0f1729] to-[#0a0e1a] border-2 border-amber-500/40 rounded-2xl p-6 md:p-10 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-3458">
            {/* Value Anchor */}
            <div className="text-center" data-id="element-3459">
              <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-5" data-id="element-3460">
                Valor Real vs Inversión Hoy
              </h2>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-3461">
                Si pagaras a un copywriter por crear estos 200 mensajes desde
                cero, te cobrarían entre{' '}
                <span className="text-white font-bold" data-id="element-3462">
                  $50–$100 por mensaje.
                </span>
              </p>
              <div className="flex flex-col items-center gap-1" data-id="element-3463">
                <span className="text-gray-500 text-xs md:text-sm uppercase tracking-widest" data-id="element-3464">
                  Valor en el mercado
                </span>
                <span className="text-3xl md:text-5xl font-black text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-3465">
                  $10,000 – $20,000
                </span>
              </div>
              <p className="text-gray-400 text-sm md:text-base mt-5 max-w-xl mx-auto" data-id="element-3466">
                Se paga solo con el{' '}
                <span className="text-white font-bold" data-id="element-3467">PRIMER cliente</span> que
                cierres usando UNO solo de estos mensajes.
              </p>
            </div>

            {/* Divider */}
            <div className="my-7 md:my-8 border-t border-dashed border-amber-500/20" data-id="element-3468" />

            {/* Price summary */}
            <div className="text-center mb-7" data-id="element-3469">
              <p className="text-amber-400 text-xs md:text-sm uppercase tracking-widest font-bold mb-2" data-id="element-3470">
                Hoy lo llevas por
              </p>
              <p className="text-6xl md:text-8xl font-black text-amber-400 mb-2 leading-none" data-id="element-3471">
                $27{' '}
                <span className="text-lg md:text-2xl text-gray-500 font-medium align-top" data-id="element-3472">
                  USD
                </span>
              </p>
              <p className="text-amber-400 text-sm md:text-base font-semibold" data-id="element-3473">
                Pago único · Sin suscripción
              </p>
            </div>

            {/* Main CTA Button */}
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" target="_blank" rel="noopener noreferrer" className="group block w-full" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
            }
          }} data-id="element-3474">
              <button className="relative w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-black text-base md:text-xl uppercase tracking-tight py-5 md:py-6 px-6 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-3475">
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-3476">
                  <MessageSquare className="w-5 h-5 md:w-6 md:h-6" data-id="element-3477" />
                  SÍ, QUIERO LOS 200 MENSAJES POR $27
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3478" />
              </button>
            </a>

            {/* Microcopy */}
            <div className="mt-5 flex items-center justify-center gap-x-4 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-3479">
              <span className="flex items-center gap-1.5" data-id="element-3480">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3481" />
                Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3482">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3483" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3484">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3485" />
                Pago seguro con tarjeta
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3486">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-3487" />
                Acceso de por vida
              </span>
            </div>

            {/* Downsell link — right under the CTA so users don't miss the next step */}
            <div className="text-center mt-4" data-id="element-3488">
              <Link to="/thank-you-downsale" className="text-white hover:text-gray-200 text-sm md:text-base underline underline-offset-4 transition-colors" data-id="element-3489">
                No gracias, solo quiero ir al webinar →
              </Link>
            </div>

            {/* Guarantee Block */}
            <div className="mt-7 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center gap-4" data-id="element-3490">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-500/10 rounded-full flex items-center justify-center border border-emerald-500/20 flex-shrink-0" data-id="element-3491">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-3492" />
              </div>
              <div className="text-center md:text-left" data-id="element-3493">
                <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-3494">
                  Garantía Incondicional de 7 Días
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-3495">
                  Si no encuentras valor en el manual, te devuelvo el 100% de tu
                  inversión. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust footer note */}
        <div className="text-center text-gray-600 text-xs md:text-sm pt-6" data-id="element-3496">
          <Clock className="w-4 h-4 inline mr-1.5 mb-0.5" data-id="element-3497" />
          Esta oferta no estará disponible después de salir de esta página.
        </div>
      </main>

      <Footer data-id="element-3498" />
    </div>;
}